<template>
  <ImageQuestion
    class="video"
    v-bind:data="data"
  >
    <!-- <div class="sound-icon">Играет музыка</div> -->

    <div
      class="video-wrapper"
      v-bind:class="{ muted: isMuted }"
      v-on:click="unmutePlayer"
      v-show="isVideoPlaying"
    >
      <VideoPlayer
        v-bind:url="data.media"
        v-bind:muted="isMuted"
        v-on:videoStop="videoStop"
        ref="videoPlayer"
      />
    </div>
  </ImageQuestion>
</template>

<script>
import canAutoplay from 'can-autoplay';
import * as AppSound from '../../../state/AppSound';
import ImageQuestion from './ImageQuestion.vue';

const VideoPlayer = () => import('../../shared/VideoPlayer.vue');

export default {
  name: 'VideoQuestion',

  components: {
    ImageQuestion,
    VideoPlayer,
  },

  props: {
    data: Object,
    meta: Object,
  },

  data() {
    return {
      isVideoPlaying: true,
      isMuted: !AppSound.getters.isSoundOn(),

      player: null,
      hls: null,
    };
  },

  computed: {
    volumeOn: AppSound.getters.isSoundOn,
  },

  mounted() {
    canAutoplay.video()
      .then(({ result }) => {
        if (!result) {
          // set muted
          this.isMuted = true;
        }

        setTimeout(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
            this.isVideoPlaying = true;
          }
        }, 1e3);
      });
  },

  methods: {
    videoStop() {
      this.isVideoPlaying = false;
    },

    unmutePlayer() {
      this.isMuted = false;
      AppSound.mutations.onSound();
      this.$refs.videoPlayer.play();
      this.isVideoPlaying = true;
    },
  },

  watch: {
    volumeOn(sonundOn) {
      this.isMuted = !sonundOn;
    },
  },
};
</script>
